export const dayNames = {
  TODAY: 'today',
  YESTERDAY: 'yesterday',
};
